import { useState, useEffect, useCallback } from 'react'
import { useDescricaoTecnicaVestigioService } from 'hooks/useDescricaoTecnicaVestigioService'

export const useDescricoesTecnicasVestigio = ({ idVestigio, idExameRealizado, setAtualizado }) => {
  const descricaoTecnicaService = useDescricaoTecnicaVestigioService()

  const [descricoesTecnicas, setDescricoesTecnicas] = useState([])
  const [processandoDescricoesTecnicas, setProcessandoDescricoesTecnicas] = useState(false)
  const [openHistorico, setOpenHistorico] = useState(false)
  const [historico, setHistorico] = useState([])
  const [processandoHistorico, setProcessandoHistorico] = useState(false)
  const [openDeletarDescricao, setOpenDeletarDescricao] = useState(false)
  const [openInativarDescricao, setOpenInativarDescricao] = useState(false)
  const [processandoOperacao, setProcessandoOperacao] = useState(false)
  const [idDescricaoSelecionada, setIdDescricaoSelecionada] = useState(null)

  const fetchDescricoesTecnicasDeVestigio = useCallback(async () => {
    if (idVestigio) {
      setProcessandoDescricoesTecnicas(true)
      try {
        const response = await descricaoTecnicaService.listarDescricoesTecnicasAtivasDeVestigioAsync(idVestigio, setProcessandoDescricoesTecnicas)
        setDescricoesTecnicas(response || [])
      } catch (error) {
        console.error('Error fetching technical descriptions:', error)
      } finally {
        setProcessandoDescricoesTecnicas(false)
      }
    }
  }, [idVestigio])

  const fetchHistoricoDescricoesTecnicas = useCallback(async () => {
    if (idVestigio && openHistorico) {
      setProcessandoHistorico(true)
      try {
        const response = await descricaoTecnicaService.listarDescricoesTecnicasDeVestigoAsync(idVestigio, setProcessandoHistorico)
        setHistorico(response || [])
      } catch (error) {
        console.error('Error fetching descriptions history:', error)
      } finally {
        setProcessandoHistorico(false)
      }
    }
  }, [openHistorico, idVestigio])

  const handleClickDesconsiderarDescricao = useCallback((idDescricao) => {
    setIdDescricaoSelecionada(idDescricao)
    setOpenInativarDescricao(true)
  }, [])

  const handleClickDeletarDescricao = useCallback((idDescricao) => {
    setIdDescricaoSelecionada(idDescricao)
    setOpenDeletarDescricao(true)
  }, [])



  const handleClickConfirmarDeletarDescricao = useCallback(async () => {
    if (!idDescricaoSelecionada) return
    setProcessandoOperacao(true)
    try {
      await descricaoTecnicaService.deletarDescricaoTecnicaVestigio(idDescricaoSelecionada, setProcessandoOperacao)
      if (setAtualizado) setAtualizado((prevState) => !prevState)
      setOpenDeletarDescricao(false)
      await fetchDescricoesTecnicasDeVestigio()
      setIdDescricaoSelecionada(null)
    } catch (error) {
      console.error('Error deleting description:', error)
    } finally {
      setProcessandoOperacao(false)
    }
  }, [idDescricaoSelecionada, fetchDescricoesTecnicasDeVestigio, setAtualizado])

  const handleClickConfirmarInativarDescricao = useCallback(async () => {
    if (!idDescricaoSelecionada) return
    setProcessandoOperacao(true)
    try {
      await descricaoTecnicaService.inativarDescricaoTecnicaVestigio(idDescricaoSelecionada, setProcessandoOperacao)
      if (setAtualizado) setAtualizado((prevState) => !prevState)
      setOpenInativarDescricao(false)
      await fetchDescricoesTecnicasDeVestigio()
      setIdDescricaoSelecionada(null)
    } catch (error) {
      console.error('Error inactivating description:', error)
    } finally {
      setProcessandoOperacao(false)
    }
  }, [idDescricaoSelecionada, fetchDescricoesTecnicasDeVestigio, setAtualizado])


  const handleClickHistorico = useCallback(() => {
    setOpenHistorico(true)
  }, [])

  useEffect(() => {
    fetchDescricoesTecnicasDeVestigio()
  }, [fetchDescricoesTecnicasDeVestigio])

  useEffect(() => {
    fetchHistoricoDescricoesTecnicas()
  }, [fetchHistoricoDescricoesTecnicas])

  return {
    descricoesTecnicas,
    processandoDescricoesTecnicas,
    openHistorico,
    setOpenHistorico,
    historico,
    processandoHistorico,
    openDeletarDescricao,
    setOpenDeletarDescricao,
    openInativarDescricao,
    setOpenInativarDescricao,
    processandoOperacao,
    handleClickDesconsiderarDescricao,
    handleClickDeletarDescricao,
    handleClickConfirmarDeletarDescricao,
    handleClickConfirmarInativarDescricao,
    handleClickHistorico,
    fetchDescricoesTecnicasDeVestigio,
  }
}
